import { render, staticRenderFns } from "./FinancialInstitution.vue?vue&type=template&id=6f06982b&scoped=true&"
import script from "./FinancialInstitution.vue?vue&type=script&lang=js&"
export * from "./FinancialInstitution.vue?vue&type=script&lang=js&"
import style0 from "./FinancialInstitution.vue?vue&type=style&index=0&id=6f06982b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f06982b",
  null
  
)

export default component.exports